import { Record as record, List } from 'immutable';
import Joi from 'joi';

import { sum } from '../../helpers/Immutable';
import { translate as t } from '../../lib/I18n';
import validation from '../../validation';
import ValidationMixin from '../ValidationMixin';

const defaults = {
    adults: 1,
    children: 0,
    railcards: new List()
};

class PassengersForm extends record(defaults) {

    getComputedValues () {

        const { adults, children, railcards } = this;
        const total = adults + children;
        const railcardsCount = railcards ? sum(railcards, 'quantity') : 0;

        return {
            total,
            railcards: railcardsCount
        };
    }

    getSchema () {
        const passenger = Joi.number().min(0).max(9).required();

        return {
            adults: passenger,
            children: passenger,
            railcards: validation.railcardsNumber('total'),
            total: Joi.number().min(1).max(9).required().options({
                language: {
                    number: {
                        base: t('booking.passengers.errors.atLeastOne'),
                        min: t('booking.passengers.errors.atLeastOne'),
                        max: t('booking.passengers.errors.upToNine')
                    }
                }
            })
        };
    }
}

Object.assign(PassengersForm.prototype, ValidationMixin);

export default PassengersForm;



// WEBPACK FOOTER //
// ./src/records/search/PassengersForm.js